<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2 col-12">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10 col-12">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Clientes</h2>
                </div>
                <div class="col-lg-2">
                    <br>
                    <button (click)="openModal(myModalUsuario)" type="button" class="boton fondoAmarillo blanco bold" > Agregar <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg> </button>
                </div>
            </div>
            <i>Nota: solo se muestran los últimos 100 registros. Utiliza los filtros para encontrar más resultados.</i>

            <br><br>
            <div class="row">
                <div class="col-lg-3">
                    <span class="bod">Filtrar por grupo:</span><br>

                    <div class="ng-autocomplete">
                        <ng-autocomplete 
                          [data]="grupos"
                          [searchKeyword]="keyword"
                          (selected)='selectEvent($event)'
                          (inputChanged)='onChangeSearch($event)'
                          (inputFocused)='onFocused($event)'
                          [itemTemplate]="itemTemplate"
                          [notFoundTemplate]="notFoundTemplate">                                 
                        </ng-autocomplete>
                        
                        <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item.nombre"></a>
                        </ng-template>
                        
                        <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound">No hay resultados</div>
                        </ng-template>
                    </div>
                </div>

                <div class="col-lg-3">
                    <span class="bod">Buscar por nombre:</span><br>
                    <input [(ngModel)]="filtro.alumno" type="text" class="form-control" placeholder="Nombre del cliente">
                </div>
                <div class="col-lg-3">
                    <span class="bod">Buscar por apellido:</span><br>
                    <input [(ngModel)]="filtro.apellidos" type="text" class="form-control" placeholder="Apellidos del cliente">
                </div>
                <div class="col-lg-3"><br>
                    <button class="btn btn-success" (click)="getClientesFiltroText()">Filtrar</button>
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-lg-3">
                    <span class="bod">Seleccionar Grupo:</span><br>
                    <select class="form-control" [(ngModel)]="filtro.grupo">
                        <option value="">Selecciona Grupo</option>
                        <option *ngFor = "let grupoF of grupos" [value]="grupoF.id">{{grupoF.nombre}}</option>
                    </select>
                </div>
                <div class="col-lg-3">
                    <br>
                    <button class="btn btn-success" (click)="getClientesFiltro()">Filtrar</button>
                </div> -->
                <br>
                
            </div>

            <div class="row">
                <div class="col-lg-11">
                    <br>
                    <!-- <div class="input-group mb-2 mr-sm-2">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                              </svg>
                          </div>
                        </div>
                        <input type="text" class="form-control" [(ngModel)]="buscar" (ngModelChange)="search()" placeholder="Buscar">
                      </div> -->
                    <br>
                    <table  class="table table-striped row-border hover"  datatable [dtOptions]="dtOptions"
                    [dtTrigger]="dtTrigger" style="text-align: center;">
                        <thead class="thead-dark">
                            <tr>
                                <td>ID</td>
                                <td>Nombre</td>
                                <td>Celular</td>
                                <td>Grupo</td>
                                <td>Estatus</td>
                                <td>Paquete</td>
                                <td>Contrato</td>
                                <td>Pagos</td>
                                <td>Comprobante</td>
                                <td>Editar</td>
                                <td>
                                    <div *ngIf="dataCliente.acceso_pagos == 1">Eliminar</div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cliente of clientes">
                                <td>{{cliente.id}}</td>
                                <td>{{cliente.nombre}}</td>
                                <td>{{cliente.celular}}</td>
                                <td>{{cliente.grupo}}</td>
                                <td>
                                    <div *ngIf="cliente.estatus==0">
                                        <svg style="color:white; border:1px solid black;" width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="8" cy="8" r="8"/>
                                          </svg>
                                    </div>

                                    <div *ngIf="cliente.estatus==1">
                                        <svg style="color:red;" width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="8" cy="8" r="8"/>
                                          </svg>
                                    </div>
                                    
                                    <div *ngIf="cliente.estatus==2">
                                        <svg style="color:orange;" width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="8" cy="8" r="8"/>
                                          </svg>
                                    </div>

                                    <div *ngIf="cliente.estatus==3">
                                        <svg style="color:yellow" width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="8" cy="8" r="8"/>
                                      </svg>
                                    </div>
                                    
                                    <div *ngIf="cliente.estatus==4">
                                        <svg style="color:#1FAD5C;" width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="8" cy="8" r="8"/>
                                      </svg>
                                    </div>
                                </td>
                                <td><a href="detalle-paquete/{{cliente.id}}"><button type="button" class="btn btn-primary">Ver Paquete</button></a></td>
                                <td><a href="assets/contratos/contrato_imprimir.pdf" target="blank">
                                    <button type="button" class="btn btn-warning">Ver Contrato</button>
                                </a></td>
                                <td><button type="button" class="btn btn-success" (click)="getPagos(cliente.id)">Ver Pagos</button></td>
                                <td>
                                    <a *ngIf="cliente.comprobante_pago" [href]="environment + cliente.comprobante_pago" target="_blank" rel="noopener">
                                        <button type="button" class="btn btn-secondary">Ver</button>
                                    </a>
                                    <span *ngIf="!cliente.comprobante_pago">-</span>
                                </td>
                                <td><button type="button" class="btn btn-info" (click)="editarCliente(cliente.id)">Editar</button></td>
                                <td>
                                    <div *ngIf="dataCliente.acceso_pagos == 1">
                                    <button class="btn btn-danger" (click)="eliminarCliente(cliente.id)">Eliminar</button>
                                  </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</div>

<div id="click" (click)="openModal(myModal)"></div>
<ng-template #myModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Historial de Pagos</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <p>
            <span *ngIf="datos_grupo.forma_pago == 1">Plan 1 50/50 <br></span>
            <span *ngIf="datos_grupo.forma_pago == 2">Plan 2 30/30/40 <br></span>
            <span *ngIf="datos_grupo.fecha_pago_uno">Fecha de pago 1: {{datos_grupo.fecha_pago_uno}}<br></span>
            <span *ngIf="datos_grupo.fecha_pago_dos">Fecha de pago 2: {{datos_grupo.fecha_pago_dos}}<br></span>
            <span *ngIf="datos_grupo.fecha_pago_tres">Fecha de pago 3: {{datos_grupo.fecha_pago_tres}}<br></span>
            
        </p>
        <table class="table table-striped center">
            <thead>
                <tr>
                    <td>ID Pago</td>
                    <td>Folio</td>
                    <td>Fecha</td>
                    <td>Monto</td>
                    <td>Forma de Pago</td>
                    <td>Tipo Pago</td>
                    <td>Registró</td>
                    <td>Recibo</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let pago of pagos">
                    <td>{{pago.id}}</td>
                    <td>{{pago.folio}}</td>
                    <td>{{pago.fecha}}</td>
                    <td>${{pago.monto}}</td>
                    <td>{{pago.forma_pago}}</td>
                    <td>{{pago.tipo_pago}}</td>
                    <td>{{pago.registro}}</td>
                    <td><a href="{{environment}}/api/reciboPago?pago={{pago.id}}" target="_blank">Ver Pago</a></td>
                </tr>
                <tr>
                    <td class="bold">Total</td>
                    <td class="bold">${{total}}</td>
                </tr>
            </tbody>
        </table>
        <p class="center">Saldo <strong>${{saldo}}</strong> de <strong>${{totalCliente}}</strong></p>
    </div>

    <div class="modal-footer">
        <div class="row">
            <div class="col-lg-3">
                <div class="input-group">
                    <input id="fecha_pago_1" class="form-control"  [(ngModel)]="formulario.fecha" placeholder="Fecha de pago yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
                    <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                        <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                    </button>
                    </div>
                </div>
                <br>
            </div>

            <div class="col-lg-3">
                <input type="text" placeholder="Folio" class="form-control" [(ngModel)]="formulario.folio">
            </div>

            <div class="col-lg-3">
                <input type="text" placeholder="Monto" class="form-control" [(ngModel)]="formulario.monto">
            </div>

            <div class="col-lg-3">
                <select #metodoPago class="form-control">
                    <option value="Efectivo">Efectivo</option>
                    <option value="Depósito Bancario">Depósito Bancario</option>
                    <option value="Transferencia Electrónica">Transferencia Electrónica</option>
                    <option value="Tarjeta de Crédito">Tarjeta de Crédito</option>
                    <option value="Tarjeta de Débito">Tarjeta de Débito</option>
                </select>
            </div>

            <div class="col-lg-3">
                <select #metodoPago class="form-control" [(ngModel)]="formularioPago.tipo_pago">
                    <option value="">Seleccione tipo de pago</option>
                    <option value="Cuadros">Cuadros</option>
                    <option value="Viaje">Viaje</option>
                    <option value="Fiesta">Fiesta</option>
                </select>
        
            </div>
        </div>
        

        
       

       
        
        <button class="btn btn-primary" (click)="agregarPago(usuarioid, metodoPago.value)">Agregar Pago</button>
    </div>
</ng-template>

<ng-template #myModalUsuario let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Cliente</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario2.nombre"><br>
        <input type="text" class="form-control" placeholder="Apellido Paterno" [(ngModel)]="formulario2.apellidos"><br>
        <input type="text" class="form-control" placeholder="Apellido Materno" [(ngModel)]="formulario2.apellido_materno"><br>
        <input type="text" class="form-control" placeholder="Celular" [(ngModel)]="formulario2.celular"><br>
        <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formulario2.email"><br>
        <!-- <input type="text" class="form-control" placeholder="Monto Compra" [(ngModel)]="formulario2.monto_compra"><br> -->
        <!-- <select #carrera>
            <option value="" class="form-control">Seleccione Carrera</option>
            <option *ngFor = "let carrera of carreras" [value]="carrera.id">{{carrera.nombre}} - {{carrera.institucion}}</option>
        </select> -->
        <!-- <br><br> -->
        <!-- <select #grupo>
            <option value="" class="form-control">Seleccione Grupo</option>
            <option *ngFor = "let grupo of grupos" [value]="grupo.id" [(ngModel)]="formulario2.grupo">{{grupo.nombre}}</option>
        </select> -->

        <div class="ng-autocomplete">
            <ng-autocomplete 
              [data]="grupos"
              [searchKeyword]="keyword"
              (selected)='selectEvent2($event)'
              (inputChanged)='onChangeSearch2($event)'
              (inputFocused)='onFocused2($event)'
              [itemTemplate]="itemTemplate2"
              [notFoundTemplate]="notFoundTemplate2">                                 
            </ng-autocomplete>
            
            <ng-template #itemTemplate2 let-item>
            <a [innerHTML]="item.nombre"></a>
            </ng-template>
            
            <ng-template #notFoundTemplate2 let-notFound>
            <div [innerHTML]="notFound">No hay resultados</div>
            </ng-template>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="agregarUsuario()">Agregar Usuario</button><br>
        <p class="warning bold">{{error}}</p>
    </div>
</ng-template>


<div id="clickPaquete" (click)="openModal(mymodal2)"></div>
<ng-template #mymodal2 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Paquete</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismissAll()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
        <h5>Datos de Cliente</h5>
        <p>{{paqueteCliente.nombre}}<br>
            {{paqueteCliente.celular}}
        </p>

        <h5>Paquete</h5>

        <table class="table table-striped">
            <thead>
                <tr>
                    <td>Concepto</td>
                    <td>Precio</td>
                    <td>Eliminar</td>
                </tr>
            </thead>
            <tr>
                <td colspan="2"><span class="center bold">Paquetes</span></td>
            </tr>
            <tr *ngFor="let paqueteSelected of paqueteCliente.paquetes">
                <td>
                    <p>{{paqueteSelected.paquete}}</p>
                </td>
                <td>
                    <p>{{paqueteSelected.precio | currency}}</p>
                </td>
                <td>
                    <!-- <p><a (click)="eliminarPaqueteCliente(paqueteSelected.id, clienteid)">
                     <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                         <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                         <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                       </svg>
                    </a></p> -->
                 </td>
            </tr>
            <tr>
                <td colspan="2"><span class="center bold">Productos Adicionales</span></td>
            </tr>
            <tr *ngFor="let productoAdicional of paqueteCliente.productos">
                <td>
                    <p>{{productoAdicional.producto}}</p>
                </td>
                <td>
                    <p>{{productoAdicional.precio | currency}}</p>
                </td>
                <td>
                    <!-- <p><a (click)="eliminarProductoCliente(productoAdicional.id, clienteid)">
                     <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                         <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                         <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                       </svg>
                    </a></p> -->
                 </td>
            </tr>
            <tr>
                <td colspan="2"><span class="center bold">Marcos</span></td>
            </tr>
            <tr *ngFor="let moldura of paqueteCliente.molduras">
                <td>
                    <p>{{moldura.nombre}}</p>
                </td>
                <td>
                    <p>-</p>
                </td>
                <td>
                    <!-- <p><a (click)="eliminarMoldura(moldura.id, clienteid)">
                     <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                         <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                         <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                       </svg>
                    </a></p> -->
                 </td>
            </tr>
            <tr>
                <td colspan="2"><span class="center bold">Placas</span></td>
            </tr>
            <tr *ngFor="let placa of paqueteCliente.placas">
                <td>
                    <p>{{placa.nombre}}</p>
                </td>
                <td>
                    <p>-</p>
                </td>
                <td>
                   <!-- <p><a  (click)="eliminarPlaca(placa.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                      </svg>
                    </a></p> -->
                </td>
            </tr>
            <tr>
                <td colspan="2"><span class="center bold">Colores</span></td>
            </tr>
            <tr *ngFor="let color of paqueteCliente.colores">
                <td>
                    <p>{{color.nombre}}</p>
                </td>
                <td>
                    <p>-</p>
                </td>
                <td>
                   <!-- <p><a  (click)="eliminarColorCliente(color.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                      </svg>
                    </a></p> -->
                </td>
            </tr>
            

            <tr>
                <td colspan="2"><span class="center bold">Anillos</span></td>
            </tr>
            <tr *ngFor="let anilloSelected of paqueteCliente.anillos">
                <td>{{anilloSelected.nombre}} | {{anilloSelected.metal}} <br>{{anilloSelected.gramaje}} gramos</td>
                <td>{{anilloSelected.precio | currency}}</td>
                <td>
                    <!-- <a (click)="eliminarAnilloCliente(anilloSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> -->
                </td>
            </tr>

            <tr>
                <td colspan="2"><span class="center bold">Viajes</span></td>
            </tr>
            <tr *ngFor="let viajeSelected of paqueteCliente.viajes">
                <td>{{viajeSelected.nombre}}</td>
                <td>{{viajeSelected.precio | currency}}</td>
                <td>
                    <!-- <a (click)="eliminarViajeCliente(viajeSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> -->
                </td>
            </tr>


            <tr>
                <td colspan="2"><span class="center bold">Fiestas</span></td>
            </tr>
            <tr *ngFor="let fiestaSelected of paqueteCliente.fiestas">
                <td *ngIf="fiestaSelected.boletos_adulto > 0">{{fiestaSelected.nombre}} - {{fiestaSelected.boletos_adulto}} Boletos Adulto</td>
                <td *ngIf="fiestaSelected.boletos_adulto > 0">{{fiestaSelected.boletos_adulto * fiestaSelected.precio_boletos_adulto | currency}}</td>
                <td *ngIf="fiestaSelected.boletos_adulto > 0">
                    <!-- <a (click)="eliminarBoletosAdulto(fiestaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> -->
                </td>
            </tr>


            <tr *ngFor="let fiestaSelected of paqueteCliente.fiestas">
                <td *ngIf="fiestaSelected.boletos_nino > 0">{{fiestaSelected.nombre}} - {{fiestaSelected.boletos_nino}} Boletos Niño</td>
                <td *ngIf="fiestaSelected.boletos_nino > 0">{{fiestaSelected.boletos_nino * fiestaSelected.precio_boletos_nino | currency}}</td>
                <td *ngIf="fiestaSelected.boletos_nino > 0">
                    <!-- <a (click)="eliminarBoletosNino(fiestaSelected.id, clienteid)">
                    <svg style="color: red;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </a> -->
                </td>
            </tr>

            <tr *ngFor="let descuentoAplicado of paqueteCliente.descuentos">
                <td>Código {{descuentoAplicado.codigo}}</td>
                <td>-{{descuentoAplicado.monto | currency}}</td>
                <td></td>
            </tr>

            <tr>
                <td>Total</td>
                <td>{{paqueteCliente.total | currency}}</td>
                <td></td>
            </tr>

            <tr>
                <td colspan="2"><span class="center bold">Anotaciones</span></td>
            </tr>
            <tr *ngFor="let anotacion of paqueteCliente.anotaciones">
                <td colspan="3">
                    <p>{{anotacion.texto}}</p>
                </td>
            </tr>
        </table>

        

        


        
        <br><br><br>

        <span class="bold">Agregar Anotaciones</span><br>
        <textarea placeholder="Anotaciones" class="form-control" [(ngModel)]="anotaciones.texto"></textarea><br>
      <button class="btn btn-danger" (click)="agregarAnotaciones(clienteid)">Agregar</button><br>

        <br><br>
       <span class="bold">Agregar Paquete</span>
      <select #paqueteSelect class="form-control">
          <option value="">Seleccione Paquete</option>
          <option *ngFor="let paquete of paquetes" [value]="paquete.id">{{paquete.nombre}}</option>
      </select>
      <button class="btn btn-danger" (click)="agregarPaqueteCliente(paqueteSelect.value, clienteid)">Agregar</button><br>

      <br><br>
      <span class="bold">Agregar Productos</span>
      <select #productoSelect class="form-control">
          <option value="">Seleccione Producto</option>
          <option *ngFor="let producto of productos" [value]="producto.id">{{producto.nombre}}</option>
      </select>
      <button class="btn btn-danger" (click)="agregarProductoCliente(productoSelect.value, clienteid)">Agregar</button><br>


        <br><br>
      <span class="bold">Agregar Moldura</span>
      <select #molduraSelect class="form-control">
          <option value="">Seleccione Moldura</option>
          <option *ngFor="let moldura of molduras" [value]="moldura.id">{{moldura.nombre}}</option>
      </select>
      <button class="btn btn-danger" (click)="agregarMoldura(molduraSelect.value, clienteid)">Agregar</button><br>
      
      <br>
      <span class="bold">Agregar Placas</span>
      <select #placaSelect class="form-control">
          <option value="">Seleccione Placa</option>
          <option *ngFor="let placa of placas" [value]="placa.id">{{placa.nombre}}</option>
      </select>
      <button class="btn btn-danger" (click)="agregarPlaca(placaSelect.value, clienteid)">Agregar</button>


      <br><br>
      <span class="bold">Agregar Color</span>
      <select #colorSelect class="form-control">
          <option value="">Seleccione Color</option>
          <option *ngFor="let color of colores" [value]="color.id">{{color.nombre}}</option>
      </select>
      <button class="btn btn-danger" (click)="agregarColor(colorSelect.value, clienteid)">Agregar</button>
    </div>
    <div class="modal-footer">
       

    </div>
  </ng-template>

  
    <div id="clickEditar" (click)="openModal(myModalEditarUsuario)"></div>

  <ng-template #myModalEditarUsuario let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Cliente</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.nombre"><br>
        <input type="text" class="form-control" placeholder="Apellido Paterno" [(ngModel)]="formularioEdit.apellidos"><br>
        <input type="text" class="form-control" placeholder="Apellido Materno" [(ngModel)]="formularioEdit.apellido_materno"><br>
        <input type="text" class="form-control" placeholder="Celular" [(ngModel)]="formularioEdit.celular"><br>
        <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formularioEdit.email"><br>
        <input type="password" class="form-control" placeholder="Password" [(ngModel)]="formularioEdit.password"><br>
        <!-- <select #carrera>
            <option value="" class="form-control">Seleccione Carrera</option>
            <option *ngFor = "let carrera of carreras" [value]="carrera.id">{{carrera.nombre}} - {{carrera.institucion}}</option>
        </select>-->
        <select #grupo class="form-control" [(ngModel)]="formularioEdit.grupo">
            <option value=""  class="form-control">Seleccione Grupo</option>
            <option *ngFor = "let grupo of grupos" [value]="grupo.id">{{grupo.nombre}}</option>
        </select> 
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateCliente(clienteid)">Actualizar Usuario</button>
    </div>
</ng-template>
